<template>
  <div id="filter-container">
    <header class="header-text">
      Filter Detail
    </header>
    <div class="filter-detail">
      <div
        v-for="(f, key) in filters"
        :key="key"
        class="filter-life-circle"
      >
        <svg
          v-if="key < 3"
          viewBox="0 0 36 36"
          :class="[
            f.index === 1 ? 'circular-orange-chart' : '',
            f.index === 2 ? 'circular-purple-chart' : '',
            f.index === 3 ? 'circular-darkblue-chart' : '',
          ]"
        >
          <path
            class="circle-bg"
            d="M18 2.0845
              a 15.9155 15.9155 0 0 1 0 31.831
              a 15.9155 15.9155 0 0 1 0 -31.831"
          />
          <path
            class="circle"
            :stroke-dasharray="f.filterLife"
            d="M18 2.0845
              a 15.9155 15.9155 0 0 1 0 31.831
              a 15.9155 15.9155 0 0 1 0 -31.831"
          />
        </svg>
      </div>
      <div class="filters-text">
        <div
          v-for="(f, key) in filters"
          :key="key"
          class="filter-life-text"
        >
          <div v-if="key < 3">
            {{ f.filterLifePercentage }}
          </div>
          <div
            v-if="key < 3"
            class="filter-dot-text"
          >
            <span
              :class="[
                f.index === 1 ? 'orange-dot' : '',
                f.index === 2 ? 'purple-dot' : '',
                f.index === 3 ? 'darkblue-dot' : '',
              ]"
            />
            {{ getFilterSize(f) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import systemHealthMixin from '../../mixins/systemHealthMixin';

export default {
  name: 'FilterDetail',
  mixins: [systemHealthMixin],
};
</script>

<style lang="scss">

#filter-container {
  background-color: $WHITE;
  padding: 1rem;
  box-shadow: 0 1px 10px 0 rgba(9, 15, 32, 0.1);
  min-width: 250px;
  border-radius: 4px;
  .header-text {
    padding: 4px;
    color: $N60;
    font-weight: 600;
    font-size: 17px;
    border-bottom: 1px solid $N10;
  }
  .filter-detail {
    position: relative;
    height: 80%;
    .filter-life-circle {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .circular-orange-chart {
        height: 200px;
        width: 200px;
      }
      .circular-purple-chart {
        height: 145px;
        width: 145px;
      }
      .circular-darkblue-chart {
        height: 100px;
        width: 100px;
      }
      .circular-orange-chart,
      .circular-purple-chart,
      .circular-darkblue-chart{
        .circle-bg {
          fill: none;
          stroke: #eee;
          stroke-width: 3;
        }
        .circle {
          fill: none;
          stroke-width: 3;
          stroke-linecap: round;
          animation: progress 1s ease-out forwards;
        }
      }
      .circular-orange-chart .circle {
        stroke: $SUNSET100;
      }
      .circular-purple-chart .circle {
        stroke: $PURPLE1;
      }
      .circular-darkblue-chart .circle {
        stroke: $N100;
      }
    }
    .filters-text {
      display: flex;
      position: absolute;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      right: 40px;
      top: 100%;
      left: 40px;
      gap: 20px;
      font-weight: 600;
      .filter-life-text {
        display: grid;
        grid-auto-flow: row;
        justify-items: center;
        .filter-dot-text {
          display: grid;
          grid-auto-flow: column;
          gap: 10px;
          font-size: 11px;
          font-weight: 400;
          letter-spacing: 1px;
          align-items: baseline;
          color: $N90;
          .orange-dot, .purple-dot, .darkblue-dot {
            height: 10px;
            width: 10px;
            border-radius: 50%;
            display: inline-block;
          }
          .orange-dot {
            background-color: $SUNSET100;
          }
          .purple-dot {
            background-color: $PURPLE1;
          }
          .darkblue-dot {
            background-color: $N100;
          }
        }
      }
    }
  }
}

@keyframes progress {
  0% {
    stroke-dasharray: 0 100;
  }
}
</style>
